import { Navigate } from "react-router-dom";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";
import { usePermissions } from "@/hooks/use-permissions";
import { useAssignableUsers } from "@/hooks/use-users";
import { AdminAssignmentsTable } from "@/components/project/admin/AdminAssignmentsTable";
import { AdminTimeEntriesTable } from "@/components/project/admin/AdminTimeEntriesTable";

export default function AdminTimerPage() {
  const { project, budgetLines, timeEntries } = useProjectDetailContext();
  const { isSuperadmin } = usePermissions();
  const { data: users } = useAssignableUsers();

  if (!isSuperadmin) return <Navigate to={`/prosjekter/${project.id}`} replace />;

  const userList = users ?? [];

  return (
    <div className="space-y-4 p-4">
      <div className="text-xs text-muted-foreground bg-yellow-50 border border-yellow-200 rounded p-2">
        Superadmin: Excel-aktig navigasjon — piltastene flytter mellom celler,
        Enter/F2 åpner editor, Tab/Shift+Tab og Enter/Shift+Enter commit'er og
        flytter til neste/forrige celle eller rad. Skriv et tegn på en valgt
        celle for å åpne editor og pre-fylle. Escape avbryter. "+", "Ny
        timeføring…" og "×" er også navigerbare — trykk Enter for å aktivere.
        Slett har 5s Angre.
      </div>
      <AdminAssignmentsTable
        projectId={project.id}
        budgetLines={budgetLines}
        users={userList}
      />
      <AdminTimeEntriesTable
        projectId={project.id}
        project={project}
        timeEntries={timeEntries}
        budgetLines={budgetLines}
        users={userList}
      />
    </div>
  );
}
